import { api } from '@shared-runtime/api';

import type {
  ActivateCurrencyParams,
  ActivateCurrencyResult,
} from './apiSchema';
import { normalizeActivateCurrency } from './helpers';
import type { ActivateCurrencyResponse } from './schema';

/**
 * BFF
 *
 * 1. POST /fiat/accept-tnc - 接受T&C（Retail + Institutional）
 * 2. POST /fiat/submit-edd-questions - 提交EDD问卷（仅Retail）
 * 3. POST /fiat/create-applications - 创建申请/提交POA（Retail + Institutional）
 *
 * Retail user：
 * - 1: Accept T&C
 * - 2: Submit EDD → Wait for approval
 * - 3: After EDD approved → Submit POA
 * - 4: Approve → Activate completed
 *
 * Institutional user：
 * - 1: Accept T&C
 * - 2: Submit POA (address can be empty)
 * - 3: Approve → Activate completed
 */
export async function fetchActivateCurrency(
  params: ActivateCurrencyParams,
): Promise<ActivateCurrencyResponse> {
  return api.bff
    .post<ActivateCurrencyResult>('/v1/private/fiat/activate-currency', params)
    .normalize(normalizeActivateCurrency);
}
